import { AudioInputProps } from './AudioInput.types';
import { useAudioInputController } from './useAudioInputController';
import BootstrapAudioInputView from './views/bootstrap/BootstrapAudioInputView';

// Public entry point: wires the headless controller up to the bootstrap view.
export default function AudioInput(props: AudioInputProps) {
    const controller = useAudioInputController(props);
    return <BootstrapAudioInputView props={props} controller={controller} />;
}
